export const getTransformedMarkdown = (content: string): string => {
  let contentClone = content

  /* REPLACING \\n to html <br/> in markdown tables */
  /* Match all occurences of | .... | regardless of content between pipes  */
  contentClone = contentClone.replace(/\|([^|]*?)\|/g, (match, p1) => {
    /* Replace \n\n or \n with single <br/> only within the matched group */
    return `|${p1.replace(/\\n\\n|\\n/g, '<br/>')}|`
  })

  return contentClone
}
